import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import SectionHeading from '../../../components/text/SectionHeading';
import SectionHeadingWrapper from '../../../components/text/SectionHeading/HeadingWrapper';
import CollegeHSClubCard from '../../../components/cards/CollegeHSClubCard';

import { getDashboardColleges, applySearchFilters } from '../../../actions/search-actions';

const CollegesNearMe = (props) => {
    // component props
    const { filterPreferences, auth } = props;
    // redux mapping
    const { colleges = [], loading } = props;

    useEffect(() => {
        if (!colleges.length && !loading) {
            props.getDashboardColleges(filterPreferences);
        }
    }, [filterPreferences]);

    const onViewAllClick = () => {
        const { location, lat, lng, utrMin = 1, utrMax = 16, distance, gender } = filterPreferences;
        props.applySearchFilters({
            type: 'colleges',
            startDate: moment(new Date()),
            distance,
            location,
            lat,
            lng,
            utrMin,
            utrMax,
            gender,
        }, true);
        props.history.push('/search');
    };
    const showTennisContent = auth?.feedPreferences?.showTennisContent;

    if (!!showTennisContent) {
        return (
            <div>
                <div className="row mt64">
                    <div className="col-12">
                        <SectionHeadingWrapper>
                            <SectionHeading title={'Colleges Near Me'} data-testid="dashboard.colleges-near-me.section-heading" />
                            <div className={`link clickable`} onClick={onViewAllClick} data-testid="dashboard.colleges-near-me.view-all-btn">
                                View All
                            </div>
                        </SectionHeadingWrapper>
                    </div>
                </div>
                <div className="row">
                    {colleges.length ? (
                        colleges.map((college, i) => {
                            return (
                                <div className={`col-12 col-md-4`} key={`college-${i}`}>
                                    <CollegeHSClubCard club={college.source} force={{ cardView: true }} data-testid={`dashboard.colleges-near-me.item-${college.source.id}`} />
                                </div>
                            );
                        })
                    ) : (
                        <div className="col" data-testid="dashboard.colleges-near-me.empty-message">There are no colleges in your area</div>
                    )}
                </div>
            </div>
        );
    }
    return null;
};

function mapStateToProps({ homepage, auth }) {
    const { colleges = {} } = homepage;
    const { data, loading, error } = colleges;
    return { colleges: data, loading, error, auth };
}
const mapDispatchToProps = {
    getDashboardColleges,
    applySearchFilters,
};

CollegesNearMe.propTypes = {
    auth: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CollegesNearMe));
